<template>
  <v-card>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="$emit('edit', node)" flat small color="primary"><v-icon>edit</v-icon> edit</v-btn>
      <v-btn @click="$emit('delete', node)" flat small color="primary"><v-icon>delete</v-icon> delete</v-btn>
    </v-card-actions>

    <v-card-title>
      <h2>
        {{ schema.title }} "{{ node.label }}"
        <span class="node-id">#{{ node.id }}</span>
      </h2>
    </v-card-title>

    <v-card-text>
      <table class="display-node">
        <tbody>
          <template v-for="(field, key) in schema.properties">
            <template v-if="field.type == 'object'">
              <tr v-for="(subField, subKey, index) in field.properties">
                <th v-if="index == 0" :rowspan="Object.keys(field.properties).length">{{ field.title }}</th>
                <th>{{ subField.title }}</th>
                <td>{{ node.data[key][subKey] }}</td>
              </tr>
            </template>
            <tr v-else>
              <th colspan="2">{{ field.title }}</th>
              <td>{{ node.data[key] }}</td>
            </tr>
          </template>
        </tbody>
      </table>
    </v-card-text>

  </v-card>
</template>

<script>
export default {
  name: 'display-node',

  props: ['schema', 'node']

}
</script>
